// src/redux/reducers/farmdeck/livestock-reducer.js
import * as actionTypes from 'redux/actions/action-types.js'
import { normalizeSummary } from 'helper-functions/livestock/utils/format-patcher.js'

const initialState = { mobs: { lastFetch: 0, loading: false }, animals: { lastFetch: 0, loading: false }, enumItems: { lastFetch: 0, loading: false } }

const livestock = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STORE_INIT:
            return { ...initialState }
        case actionTypes.FD_MOBS_REQUEST_SUCCESS: //mobs in that tenant
            return { ...state, mobs: { ...state.mobs, loading: false, lastFetch: Date.now(), data: { ...action.data, summary: normalizeSummary(action.data.summary) } } }
        case actionTypes.FD_MOBS_REQUEST:
            return { ...state, mobs: { ...state.mobs, loading: true } }
        case actionTypes.FD_MOBS_REQUEST_FAILURE:
            return { ...state, mobs: { ...state.mobs, loading: false, error: action.error, lastError: Date.now() } }
        case actionTypes.FD_EI_REQUEST_SUCCESS: //enumItems
            return { ...state, enumItems: { ...state.enumItems, loading: false, lastFetch: Date.now(), data: action.data } }
        case actionTypes.FD_EI_REQUEST:
            return { ...state, enumItems: { ...state.enumItems, loading: true } }
        case actionTypes.FD_EI_REQUEST_FAILURE:
            return { ...state, enumItems: { ...state.enumItems, loading: false, error: action.error, lastError: Date.now() } }
        default: {
            return state
        }
    }
}

export default livestock
